import React from 'react'
import styled from 'styled-components'

import { Input as AntInput } from 'reactstrap'

import { FONTS } from '../../constants'

export const Input = (props) => {
  return (
    <Root width={ props.width } height={ props.height }>
      <InputField
        { ...props }
        placeholder={ props.placeholder || 'Enter Here' }
      />
    </Root>
  )
}

const Root = styled.div`
    width: ${p => p.width || '100%'};
    height: ${p => p.height || '30px'};

    .form-control.is-invalid {
      border-color: #dc3545;
      background-image: none;
      box-shadow: none;
      outline: none;
      padding: 6px 12px;
    }
  
    .form-control.is-invalid:focus {
      outline: none;
      box-shadow: none;
    }
`

const InputField = styled(AntInput)`
    width: 100%;
    height: 100%;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #333333;
    border: 1px solid #C4C4C4;
    border-radius: 4px;

    ::placeholder {
      color: #C4C4C4;
    }

    :focus {
      outline: none;
      box-shadow: none;
      border: 1px solid #C4C4C4;
    }

    :disabled {
      background: #EAEAEA;
      color: #808080;
    }

    ::placeholder {
      color: #C4C4C4;
    }
`



// WEBPACK FOOTER //
// ./src/components/input/input.js